import React, { useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { AiOutlineEdit } from "react-icons/ai";
import { RiFileList3Line } from "react-icons/ri";
import InvoiceModal from "./InvoiceModal";
import StatusModal from "./StatusModal";

export default function BookingItem({ data, handleStatus, setIsLoading }) {
  const [status, setStatus] = useState("");
  const [show, setShow] = useState(false);
  const [showStatus, setShowStatus] = useState(false);
  const isAdmin = localStorage.getItem("isAdmin");

  const handleClose = () => setShow(!show);
  const handleCloseStatus = () => setShowStatus(!showStatus);

  return (
    <tr className="booking-item">
      <td>{data.booking_service.title}</td>
      <td>
        {data.booking_parent.firstName + " " + data.booking_parent.lastName}
      </td>
      <td>{data.datedOn}</td>
      <td>
        <p className={"status mb-0 px-2 py-1 " + data.status}>{data.status}</p>
      </td>
      <td>
        <div className="d-flex justify-content-center">
          <Button variant="icon" className="me-2" onClick={handleClose}>
            <RiFileList3Line size={18} />
          </Button>
          {isAdmin != 0 && (
            <Dropdown>
              <Dropdown.Toggle variant="icon">
                <AiOutlineEdit size={18} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item
                  onClick={() => {
                    setStatus("paid");
                    handleCloseStatus();
                  }}
                >
                  Paid
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    setStatus("unpaid");
                    handleCloseStatus();
                  }}
                >
                  Unpaid
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
        <InvoiceModal data={data} show={show} handleClose={handleClose} />
        <StatusModal
          id={data.bookingId}
          status={status}
          show={showStatus}
          handleClose={handleCloseStatus}
          handleStatus={handleStatus}
          setIsLoading={setIsLoading}
        />
      </td>
    </tr>
  );
}
